// Create your own 'enhanced' model
Backbone.RESTModel = Backbone.DeepModel.extend({
  parse: function(response, options){
    if (options.collection){
      return response;
    }

    // Remap custom values
    if(_.has(response.data, 'custom_values')){
      var tmp = {};
      _.each(response.data.custom_values, function(custom_value, key, list){
        if(_.isArray(custom_value.value) && _.size(custom_value.value) > 0){
          var tmp2 = [];
          _.each(custom_value.value, function(repeating_group, key, list) {
            var tmp3 = {};
            _.each(repeating_group, function(repeating_group_field, key, list) {
              tmp3[repeating_group_field.custom_field_id] = repeating_group_field.value;
            }, this);
            tmp2.push(tmp3);
          }, true);

          tmp[custom_value.custom_field_id] = tmp2;
        }else{
          tmp[custom_value.custom_field_id] = custom_value.value;
        }
      }, this);

      response.data.custom_values = tmp;
    }

    return response.data;
  },

  sync: function (method, model, options) {
    if(method === 'create' || method === 'update' || method == 'patch'){
      options.data = JSON.stringify(this.parseSaveMap(options.attrs, this.saveMap));
      console.log('Data to be updated: ', options.data);
      options.contentType = 'application/json';
    }

    return Backbone.Model.prototype.sync.apply(this, arguments);
  }
});
